import Highway from '@dogstudio/highway'
import gsap from 'gsap'
import { classesInjection } from '../utils/transitions'

const duration = 0.3

/**
 * Fade page content only — persistent background canvas stays visible.
 */
function contentTargets(view) {
  return [...view.children].filter(
    (el) => !el.hasAttribute('data-module-background')
  )
}

class FadeTransition extends Highway.Transition {
  in ({ from, to, done }) {
    classesInjection(to)

    from.remove()

    const targets = contentTargets(to)
    if (!targets.length) {
      done()
      return this
    }

    gsap.fromTo(
      targets,
      { opacity: 0 },
      {
        opacity: 1,
        duration,
        onComplete: done
      }
    )
    return this
  }

  out ({ from, done }) {
    const targets = contentTargets(from)
    if (!targets.length) {
      done()
      return this
    }

    gsap.fromTo(
      targets,
      { opacity: 1 },
      {
        opacity: 0,
        duration,
        onComplete: done
      }
    )
    return this
  }
}

export default FadeTransition
